import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { Checkbox, TextInput } from '../../../../../components'
import { THEMES } from '../../../../../utils/ui'

/**
 * Contact Information
 */
class ContactInformation extends PureComponent {
  /**
   * Render GDPR option
   * @param field
   * @param value
   * @return {*}
   */
  renderGDPROption (field, value) {
    const { onCheck } = this.props
    return (
      <Checkbox
        id={`${field}-GDPR`}
        theme={THEMES.WHITES}
        label={'GDPR'}
        labelAlign='left'
        isChecked={value}
        onChange={(value) => onCheck(field, value)} />
    )
  }

  /**
   * Render
   * @return {XML}
   */
  render () {
    const { values, errors, gdpr = [], onChange } = this.props
    const phone = gdpr.includes('directPhone')
    const email = gdpr.includes('email')
    const mobile = gdpr.includes('mobile')

    return (
      <Grid item xs={9} container spacing={3}>
        <Grid item xs={12}>
          <div className='section_title'>Contact Information</div>
        </Grid>

        <Grid item xs={12} container spacing={3}>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Direct Phone</label>
              <div className='field-flexed'>
                <TextInput
                  id='directPhone'
                  value={phone ? '' : values.directPhone}
                  placeholder={phone ? 'Removed due to GDPR' : ''}
                  disabled={phone}
                  onChange={onChange} />
                {this.renderGDPROption('directPhone', phone)}
              </div>
            </div>
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Extension</label>
              <TextInput
                id='phoneExtension'
                value={phone ? '' : values.phoneExtension}
                placeholder={phone ? 'Removed due to GDPR' : ''}
                disabled={phone}
                onChange={onChange} />
            </div>
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Email Address</label>
              <div className='field-flexed'>
                <TextInput
                  id='email'
                  error={errors.email}
                  errorMessage={errors.email}
                  value={email ? '' : values.email}
                  placeholder={email ? 'Removed due to GDPR' : ''}
                  disabled={email}
                  onChange={onChange} />
                {this.renderGDPROption('email', email)}
              </div>
            </div>
          </Grid>
        </Grid>

        <Grid item xs={12} container spacing={3}>
          <Grid item xs={4}>
            <div className='field field--text'>
              <label className='field_label'>Mobile Phone</label>
              <div className='field-flexed'>
                <TextInput
                  id='mobile'
                  value={mobile ? '' : values.mobile}
                  placeholder={mobile ? 'Removed due to GDPR' : ''}
                  disabled={mobile}
                  onChange={onChange} />
                {this.renderGDPROption('mobile', mobile)}
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

ContactInformation.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired
}

export default ContactInformation
